import './ToggleButtonGroupUiObject.scss';
import './Ribbon.scss';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, ToggleButton, Typography } from '@mui/material';
import { calculatePrice } from '../common/OrderUtils';
import { useLanguage } from '../common/GeneralUtils';
import { customerFacingPriceFormatter } from '../utils/utils';

const ToggleButtonGroupUiObjectDynamicPrice = (props) => {
  const { uiObject, orderState, setOrderDetailValue } = props;
  const { t } = useTranslation();
  const language = useLanguage();

  const getDefaultValue = () => {
    return `${orderState.details[uiObject.data_type]}`;
  };

  const [value, setValue] = useState(getDefaultValue());
  const onValueChange = (e, val) => {
    if (val != null) {
      // for deselection
      setValue(val);
      setOrderDetailValue(uiObject.data_type, val);
    }
  };

  const getPrice = (value) => {
    const tempDetails = {
      ...orderState.details,
      [uiObject.data_type]: value,
    };

    return calculatePrice(orderState.orderPage, tempDetails, orderState.dateAndTimeDetails);
  };

  return (
    <Box className="toggle-button-ui-object" sx={{ marginBottom: 0 }}>
      <Typography variant="h6" bold>
        {uiObject.label[language]}
      </Typography>
      <Box className="toggle-button-container" sx={{ display: 'inline-block', marginBottom: '0!important' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left" />
              <TableCell align="center">
                <Typography>{t('order_page.table.price')}</Typography>
              </TableCell>
              <TableCell align="center" />
            </TableRow>
          </TableHead>
          <TableBody>
            {uiObject.options.map((option) => {
              return (
                <TableRow key={option.value} onClick={(e) => onValueChange(e, option.value)}>
                  <TableCell align="left" sx={{ paddingInlineStart: 0 }}>
                    <ToggleButton
                      sx={{ width: '140px', height: '60px' }}
                      className="toggle-button"
                      color="primary"
                      selected={option.value === value}
                      value={`${option.value}`}>
                      <Grid item>
                        <Grid item className="ribbon" hidden={!option.recommended}>
                          <Typography color="primary">{t('recommended')}</Typography>
                        </Grid>
                        <Typography>{option.label[language]}</Typography>
                      </Grid>
                    </ToggleButton>
                  </TableCell>
                  <TableCell align="center">
                    <Typography>{customerFacingPriceFormatter(getPrice(option.value), orderState.account)}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography style={{ opacity: 0.7, textTransform: 'none' }}>
                      {`${customerFacingPriceFormatter(
                        Math.round(getPrice(option.value) / orderState.details.persons),
                        orderState.account,
                      )} ${t('order_page.table.participant')}`}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default ToggleButtonGroupUiObjectDynamicPrice;
